import React, {useState} from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import {
  wizardAllObjectInterface,
  wizardGroupInterface,
} from "../../../../interfaces/wizardItemInterface";
import {setWizardSelectedValues} from "../../../../actions/wizardFunctions";
import {getWizardProductGroupName} from "../../../look/lookNavigation/lookMain/lookWizard/lookWizardFunctions";
import {checkForWizardPreviousChanges} from "../advancedQuotingFunctions";

const AdvancedQuotingWizardGroupsSearch = (props) => {

  const {wizardAllObject, currentGroups, stepIndex, setWizardSelectedValues, wizardList, isDisabled} = props;
  const {wizardSelectedValues, quoteIndex, wizardItemId} = wizardAllObject;

  const defaultText = wizardSelectedValues[stepIndex] && wizardSelectedValues[stepIndex].wizardGroup
    ? getWizardProductGroupName(wizardSelectedValues[stepIndex].wizardGroup) : "";
  const [productText, setProductText] = useState(defaultText);
  const [dropdownVisible, setDropdownVisible] = useState(false);

  const handleInputChange = async (event) => {
    setProductText(event.target.value);
    setDropdownVisible(true);
  }

  const handleInputFocus = () => {
    setDropdownVisible(true);
    window.addEventListener('click', handleWrapperBlur);
  }

  const handleWrapperBlur = (event) => {
    const disallowClasses = [".aq-dropdown", ".ui-input"];
    if (event.target && !disallowClasses.some(cls => event.target.closest(cls))) {
      closeDropdown();
    }
  };

  const closeDropdown = () => {
    setDropdownVisible(false);
    window.removeEventListener('click', handleWrapperBlur);
  };

  const handleInputBlur = () => {
    // setDropdownVisible(false);
  }

  const getNamesArray = () => {
    if (!dropdownVisible) {
      return []
    }
    const searchString = productText.toLowerCase();
    return currentGroups.filter(wizardGroup => getWizardProductGroupName(wizardGroup).toLowerCase().includes(searchString))
  }

  const updateForNewNavItem = async (wizardGroup) => {
    const wizardItem = wizardList.find(wizItem => wizItem.id === wizardItemId);
    setWizardSelectedValues({
      [stepIndex]: {
        wizardGroup,
        partId: ""
      }
    }, false, wizardItem, quoteIndex);
    setProductText(getWizardProductGroupName(wizardGroup));
    closeDropdown();
  };

  const handleNavItemClick = async (navItem) => {
    // if (checkForDeletePopup(cartItem, navItem, quoteIndex)) {
    //   return false
    // }
    if (wizardAllObject) {
      const applyFunction = updateForNewNavItem.bind(this, navItem);
      if (checkForWizardPreviousChanges(quoteIndex, wizardItemId, stepIndex, applyFunction)) {
        return false
      }
    }
    await updateForNewNavItem(navItem);
  };

  const namesArray = getNamesArray();
  const styles = {
    height: dropdownVisible ? namesArray.length * 30 : 0
  }

  return (
    <div className="aq-main__input">
      <input className={"ui-input ui-input--new ui-input--gray" + (isDisabled ? " ui-input--disabled" : "")}
             disabled={isDisabled}
             value={productText}
             onFocus={handleInputFocus}
             onBlur={handleInputBlur}
             onChange={handleInputChange}/>
      <div className="aq-dropdown" style={styles}>
        <ul className="aq-list">
          {namesArray.map((wizardGroup) => {
            return (
              <li className="aq-list__item" key={wizardGroup.id} onClick={() => handleNavItemClick(wizardGroup)}>
                {wizardGroup.productCartTitle || wizardGroup.title || wizardGroup.groupName}
              </li>
            )
          })}
        </ul>
      </div>
    </div>
  )
};

AdvancedQuotingWizardGroupsSearch.propTypes = {
  currentGroups: PropTypes.arrayOf(PropTypes.shape(wizardGroupInterface)).isRequired,
  wizardAllObject: PropTypes.shape(wizardAllObjectInterface).isRequired,
  stepIndex: PropTypes.number.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  // wizardGroup: PropTypes.shape(wizardGroupInterface).isRequired,
};

const mapStateToProps = (store) => {
  const {wizardList} = store.wizardState;
  return {
    wizardList
  }
};

const mapDispatchToProps = {
  setWizardSelectedValues
};

export default connect(mapStateToProps, mapDispatchToProps)(AdvancedQuotingWizardGroupsSearch)
